module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    attrs: {
      "id": "career-opportunities"
    }
  }, [_c('h2', [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_c('b', [_c('code', {
    staticClass: "program-info",
    domProps: {
      "innerHTML": _vm._s(_vm.pointOfContact)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.phoneNumber) ? _c('a', {
    staticClass: "contact",
    attrs: {
      "target": "_parent",
      "href": _vm.phoneNumberM
    }
  }, [_vm._v(" " + _vm._s(_vm.phoneNumber))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.email) ? _c('a', {
    staticClass: "contact",
    attrs: {
      "target": "_parent",
      "href": 'mailto:' + _vm.email
    }
  }, [_vm._v(_vm._s(_vm.email))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58b4dcf9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact_information.vue
// module id = 1126
// module chunks = 1